import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ListNotifications } from 'app/pages/notifications/components';

export const Main = () => {
  return (
    <Switch>
      <Route path='/notifications' component={ListNotifications} exact={true} />
    </Switch>
  );
};
